/**
 * AppICEMAP — Categories API
 * Fetch active category definitions from Directus.
 */

import { getClient, readItems } from "./directus.js";

const CATEGORIES_COLLECTION = "categories";

/**
 * Fetch all active categories, ordered by sort field.
 * @returns {Promise<Array>}
 */
export async function fetchCategories() {
	const client = getClient();

	try {
		const result = await client.request(
			readItems(CATEGORIES_COLLECTION, {
				fields: [
					"id",
					"slug",
					"label",
					"label_en",
					"icon",
					"color_ramp",
					"ttl_minutes",
					"marker_shape",
					"sort",
					"is_active",
					"type",
				],
				filter: {
					is_active: { _eq: true },
				},
				sort: "sort",
			}),
		);
		return Array.isArray(result) ? result : [];
	} catch (err) {
		console.error("[API] fetchCategories error:", err);
		// Return cached or empty on error
		return [];
	}
}
